// extracted by mini-css-extract-plugin
module.exports = {"wrapperTag":"Tag_wrapperTag__1Jglo"};